import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const FlagSireExcelFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Col md={4} />
      <Col md={8}>
        <Field name='flagSireExcel'>
          {({ field }) => (
            <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagSireExcel' label='Sire Version' />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagSireExcelFormGroup)
